import React from "react";
import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

const NotFoundError = () => (
  <ErrorPageWrapper>
    <span
      role="img"
      aria-label="emoji"
      className="animated fadeInDown delay-1"
      data-test-id="error-page-emoji"
    >
      😮
    </span>
    <ErrorPageText
      className="animated fadeInUp delay-2"
      data-test-id="error-page-text"
    >
      {"Sorry, we couldn't find what you're looking for!"}
    </ErrorPageText>
  </ErrorPageWrapper>
);

export const ErrorPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90%;

  span {
    font-size: 2.85em;
  }
`;

export const ErrorPageText = styled.div`
  font-size: 1.7em;
  margin-top: 30px;
  font-weight: 100;
  text-align: center;

  ${mediaMaxWidth.phone} {
    font-size: 1.4em;
  }
`;

export default NotFoundError;
